import { Router } from '@angular/router';
import {
  Component,
  OnInit,
  Input,
  ComponentFactoryResolver,
  OnDestroy,
} from '@angular/core';
import { UiStateStore } from '../../../shared/store/ui-state-store.service';
import { DataService } from '../../services/data.service';
import { JobPost } from '../../../jobs/models/job-post';
import { JobsStore } from '../../../jobs/store/jobs-store.service';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponent } from '../../../shared/components/modal/modal.component';
import { DashboardEmployerPostNewJobComponent } from '../employer/dashboard-post-new-job/dashboard-post-new-job.component';
import { ViewJobComponent } from '../../../jobs/components/view-job/view-job.component';
import { DeleteJobComponent } from '../../../jobs/components/delete-job/delete-job.component';

@Component({
  selector: 'app-dashboard-manage-jobs',
  templateUrl: './dashboard-manage-jobs.component.html',
  styleUrls: ['./dashboard-manage-jobs.component.scss'],
})
export class DashboardManageJobsComponent implements OnInit, OnDestroy {
  searchText: string;
  accountId: string;
  jobPosts: JobPost[] = [];

  constructor(
    private uiState: UiStateStore,
    public jobsStore: JobsStore,
    public dataService: DataService,
    public modalService: NgbModal,
    public resolver: ComponentFactoryResolver,
    private router: Router
  ) {}

  ngOnInit() {
    this.uiState.authenticatedUser.subscribe((user) => {
      if (!user) {
        return;
      }
      this.accountId = user.accountId;

      this.dataService.getJobPosts(this.accountId).subscribe((jobPosts) => {});
    });

    this.jobsStore.jobPosts.subscribe((jps) => {
      if (!jps) {
        return;
      }

      this.jobPosts = jps;
    });
  }

  ngOnDestroy(): void {
    this.uiState.setSelectedJobId(null);
  }

  edit(jobPostId: string): void {
    const componentFactory = this.resolver.resolveComponentFactory(
      DashboardEmployerPostNewJobComponent
    );
    const modalRef = this.modalService.open(ModalComponent, {
      size: 'lg',
      backdrop: 'static',
    });
    modalRef.componentInstance.setContent(componentFactory);

    this.uiState.setSelectedJobId(jobPostId);
  }

  view(jobPostId: string): void {
    const componentFactory =
      this.resolver.resolveComponentFactory(ViewJobComponent);
    const modalRef = this.modalService.open(ModalComponent, {
      size: 'lg',
      backdrop: 'static',
    });
    modalRef.componentInstance.setContent(componentFactory);

    this.uiState.setSelectedJobId(jobPostId);
  }

  manageProgress(jobPostId: string): void {
    window.open(`/tasks-wizard/${jobPostId}`, '_blank');
  }

  delete(jobPostId: string): void {
    const componentFactory =
      this.resolver.resolveComponentFactory(DeleteJobComponent);
    const modalRef = this.modalService.open(ModalComponent, {
      size: 'lg',
      backdrop: 'static',
    });
    modalRef.componentInstance.setContent(componentFactory);

    this.uiState.setSelectedJobId(jobPostId);
  }

  postjob(): void {
    window.open(`/tasks-wizard`, '_blank');
  }
}
